import React, { useId, useMemo, useRef } from 'react';
import { useTooltipContext } from './TooltipProvider';

function isTouchLikeDevice() {
  if (typeof window === 'undefined') return false;
  return window.matchMedia('(hover: none), (pointer: coarse)').matches;
}

export default function Tooltip({
  children,
  content,
  variant = 'info',
  icon,
  placement = 'top',
  delay,
  className = '',
  block = false,
}) {
  const {
    activeTooltip,
    openTooltip,
    closeTooltip,
    mobileTap,
  } = useTooltipContext();

  const localId = useId().replace(/:/g, '-');
  const tooltipId = useMemo(() => `mp-tooltip-${localId}`, [localId]);
  const anchorRef = useRef(null);

  if (!content) {
    return children;
  }

  const open = (customDelay) => {
    const anchor = anchorRef.current;
    if (!anchor) return;

    const rect = anchor.getBoundingClientRect();
    openTooltip({
      id: tooltipId,
      content,
      variant,
      icon,
      placement,
      customDelay,
      anchorRect: rect,
    });
  };

  const isOpen = activeTooltip?.id === tooltipId;
  const Wrapper = block ? 'div' : 'span';

  return (
    <Wrapper
      ref={anchorRef}
      className={`mp-tooltip-anchor ${block ? 'is-block' : ''} ${className}`.trim()}
      aria-describedby={tooltipId}
      onMouseEnter={() => open(delay)}
      onMouseLeave={() => closeTooltip(tooltipId)}
      onFocusCapture={() => open(0)}
      onBlurCapture={(event) => {
        if (!event.currentTarget.contains(event.relatedTarget)) {
          closeTooltip(tooltipId);
        }
      }}
      onClickCapture={() => {
        if (!mobileTap || !isTouchLikeDevice()) {
          return;
        }

        if (isOpen) {
          closeTooltip(tooltipId);
          return;
        }

        open(0);
      }}
    >
      {children}
    </Wrapper>
  );
}
